export enum AccessType {
    INDIVIDUAL = 'INDIVIDUAL',
    GROUP = 'GROUP',
    DOMAIN = 'DOMAIN',
}
